import styled from "styled-components";
import {media} from "@/styles/Qtheme.ts";
import {TabletCalVW} from "@utils/CalVW.tsx";

export const AccountSecuritySettingSection = styled.div``;

export const ProfileSecurities = styled.div`
    background-color: ${({theme}) => theme.body};
    border-radius: 6px;
    width: 1200px;
    margin-bottom: 25px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 30px;

    border: 1px solid ${({theme}) => theme.p2pBorder};

    @media ${media.desktop} {
        width: ${TabletCalVW(900)};
    }
`
